<template>
<div>
Entrada
</div>
</template>

<script>
export default {
   name: 'Inicio',
   
}
</script>



// WEBPACK FOOTER //
// InicioView.vue?99a34e02